import React from "react";
import { PaginationEdgeIcon, PaginationIcon } from "~/assets/svg/InterfaceIcon";

const Pagination = ({ pageInfo, handlePage }) => {
	function pageNumbers() {
		const result = [];
		for (let i = pageInfo?.startPage; i <= pageInfo?.endPage; i++) {
			result.push(
				<button
					key={i}
					type="button"
					onClick={() => handlePage(i)}
					className={`btn-num  ${i === pageInfo?.cPage ? "active" : ""}`}
				>
					{i}
				</button>
			);
		}

		return result;
	}

	return (
		<div className="pagination">
			<button
				type="button"
				disabled={!pageInfo?.prev}
				className="first-btn"
				onClick={() => handlePage(1)}
			>
				<PaginationEdgeIcon />
			</button>
			<button
				type="button"
				disabled={!pageInfo?.prev}
				className="prev-btn"
				onClick={() => handlePage(pageInfo?.cPage - 1)}
			>
				<PaginationIcon />
			</button>
			{pageNumbers()}
			<button
				type="button"
				disabled={!pageInfo?.next}
				className="next-btn"
				onClick={() => handlePage(pageInfo?.cPage + 1)}
			>
				<PaginationIcon />
			</button>
			<button
				type="button"
				disabled={!pageInfo?.next}
				className="last-btn"
				onClick={() => handlePage(pageInfo?.totalPages)}
			>
				<PaginationEdgeIcon />
			</button>
		</div>
	);
};

export default Pagination;
